/* global elementorFrontend, Swiper */
import $ from 'jquery';

export const sliderProductCarousel = () => {
	const parentClass = '.mi-product-carousel-container';

	if (!$(parentClass).length) return;

	const toggleNavigationVisibility = function (swiperInstance, $container) {
		if (!swiperInstance || !swiperInstance.slides) return;
		const totalSlides = swiperInstance.slides.length;
		const slidesPerView = swiperInstance.params.slidesPerView;
		const isLocked = swiperInstance.isLocked || totalSlides <= slidesPerView;

		if (isLocked) {
			$container.addClass('mi-product-carousel--no-nav');
		} else {
			$container.removeClass('mi-product-carousel--no-nav');
		}
	};

	const initSwiper = function ($container) {
		const $slider = $container.find('.mi-product-carousel-slider');
		if (!$slider.length) return;

		const slidesDesktop = parseInt($container.data('slides-desktop')) || 3;
		const slidesTablet  = parseInt($container.data('slides-tablet')) || 2;
		const slidesMobile  = parseInt($container.data('slides-mobile')) || 1;
		const spaceBetween  = parseInt($container.data('space-between')) || 24;
		const isAutoplay    = $container.data('autoplay') === true || $container.data('autoplay') === 'true';
		const autoSpeed     = parseInt($container.data('autoplay-speed')) || 5000;

		const params = {
			slidesPerView: slidesMobile,
			spaceBetween: spaceBetween,
			watchOverflow: true,
			loop: false,
			autoplay: isAutoplay ? { delay: autoSpeed, disableOnInteraction: false } : false,
			pagination: {
				el: $container.find('.mi-product-carousel-pagination')[0],
				clickable: true,
			},
			navigation: {
				nextEl: $container.find('.mi-product-carousel-next')[0],
				prevEl: $container.find('.mi-product-carousel-prev')[0],
			},
			breakpoints: {
				600: {
					slidesPerView: slidesTablet,
					spaceBetween: spaceBetween,
				},
				1024: {
					slidesPerView: slidesDesktop,
					spaceBetween: spaceBetween,
				},
			},
			on: {
				init: function () {
					toggleNavigationVisibility(this, $container);
				},
				breakpoint: function () {
					toggleNavigationVisibility(this, $container);
				},
				resize: function () {
					toggleNavigationVisibility(this, $container);
				},
			},
		};

		if (typeof elementorFrontend !== 'undefined' && elementorFrontend.utils && elementorFrontend.utils.swiper) {
			const asyncSwiper = elementorFrontend.utils.swiper;
			new asyncSwiper($slider, params).then(function (newSwiperInstance) {
				$slider.data('swiper', newSwiperInstance);
				toggleNavigationVisibility(newSwiperInstance, $container);
			});
		} else if (typeof Swiper !== 'undefined') {
			const newSwiper = new Swiper($slider[0], params);
			$slider.data('swiper', newSwiper);
			toggleNavigationVisibility(newSwiper, $container);
		}
	};

	$(window).on('elementor/frontend/init', function () {
		if (typeof elementorFrontend !== 'undefined' && elementorFrontend.hooks) {
			elementorFrontend.hooks.addAction(
				'frontend/element_ready/product-carousel.default',
				function ($element) {
					initSwiper($element);
				}
			);
		}
	});

	// Immediate initialization for non-Elementor or pre-initialized frontend pages
	$(parentClass).each(function () {
		initSwiper($(this));
	});
};

try {
	sliderProductCarousel();
} catch (error) {
	console.warn(error);
}
